import { render, staticRenderFns } from "./RollCall.vue?vue&type=template&id=a1d4646a&scoped=true&"
import script from "./RollCall.vue?vue&type=script&lang=js&"
export * from "./RollCall.vue?vue&type=script&lang=js&"
import style0 from "./RollCall.vue?vue&type=style&index=0&id=a1d4646a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d4646a",
  null
  
)

export default component.exports